/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Whether the local hook should allow or deny the action.
 */
export const IngestHookResultDecision = {
  Allow: "allow",
  Deny: "deny",
} as const;
/**
 * Whether the local hook should allow or deny the action.
 */
export type IngestHookResultDecision = OpenEnum<
  typeof IngestHookResultDecision
>;

/**
 * Provider-neutral decision returned by the unified hook endpoint.
 */
export type IngestHookResult = {
  /**
   * Whether the local hook should allow or deny the action.
   */
  decision: IngestHookResultDecision;
  /**
   * Optional side-effect hints for hook SDKs.
   */
  effects?: { [k: string]: any } | undefined;
  /**
   * User-facing decision message.
   */
  message?: string | undefined;
  /**
   * Machine-readable decision reason.
   */
  reason?: string | undefined;
};

/** @internal */
export const IngestHookResultDecision$inboundSchema: z.ZodMiniType<
  IngestHookResultDecision,
  unknown
> = openEnums.inboundSchema(IngestHookResultDecision);

/** @internal */
export const IngestHookResult$inboundSchema: z.ZodMiniType<
  IngestHookResult,
  unknown
> = z.object({
  decision: IngestHookResultDecision$inboundSchema,
  effects: z.optional(z.record(z.string(), z.any())),
  message: z.optional(z.string()),
  reason: z.optional(z.string()),
});

export function ingestHookResultFromJSON(
  jsonString: string,
): SafeParseResult<IngestHookResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => IngestHookResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'IngestHookResult' from JSON`,
  );
}
